import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { KoddiTheme } from './ThemeProvider.types';

export function useKoddiTheme(): KoddiTheme {
    return useContext(ThemeContext);
}
